import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedHandbookArticlesConverter extends CmsConverterService<PanelRowRelatedHandbookArticlesData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      links: formData.st_panel_row_related_handbook_articles_links_list ?? defaultFSCatalog
    }
  }
}

export const PANEL_ROW_RELATED_HANDBOOK_ARTICLES_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedHandbookArticlesData>>('PanelRowRelatedHandbookArticlesConverter')

export interface PanelRowRelatedHandbookArticlesData extends ConvertedComponentData {
  links: FsCatalog;
}
